import { axiosInstance } from "./networking";

export const login = async (username: string, password: string) => {
  const url = `/auth/login`;
  try {
    const response = await axiosInstance.post(url, {
      username: username,
      password: password,
    });
    const { user, token } = response.data;
    return user;
  } catch (error) {
    console.error(
      "You have an error in your code or there are Network issues.",
      error
    );
    return null;
  }
};

export const twofalogin = async (
  username: string,
  password: string,
  twoFactorCode: string
) => {
  const url = `/auth/2fa`;
  try {
    const response = await axiosInstance.post(url, {
      username: username,
      password: password,
      code: twoFactorCode,
    });
    const { user, token } = response.data;
    return user;
  } catch (error) {
    console.error(
      "You have an error in your code or there are Network issues.",
      error
    );
    return null;
  }
};

export const validate = async (currentPath?: string): Promise<boolean> => {
  if (/^\/(unsubscribe|survey|set-password)/.test(currentPath || "")) {
    return true; // Allow public routes
  }

  try {
    const response = await axiosInstance.get("/auth/validate");
    const { valid } = response.data;
    return valid;
  } catch (error) {
    console.error("Validation failed:", error);
    return false;
  }
};

export const logout = async () => {
  try {
    await axiosInstance.get("/auth/logout"); // Server should clear the cookie
  } catch (error) {
    console.error("Logout failed:", error);
  }
};
